import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";

class UniversalfieldShiftbookTab extends GenericListTab {

    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
    }
    ControllerUrl = "UniversalfieldShiftbookTab";
    CustomFilter() {
        if (this.TabPage.UrlData().CopyFrom != null) {
            return [{ Key: "CopyFrom", Value: this.TabPage.UrlData().CopyFrom }];
        }
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    

    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    /**
     *   
     * @returns "InitCopyFrom" when the universalfield gets copied "Init" when not
     */
    UrlInit(): string {
        return this.ControllerUrl + (this.TabPage.UrlData().CopyFrom != null ? "/InitCopyFrom" : "/Init");
    }

}
export default UniversalfieldShiftbookTab;